import { NLUuid } from '../constants';

export default list => list.filter(item => item.languageUuid === NLUuid);



// WEBPACK FOOTER //
// ./src/helpers/filterNL.js